import styled from 'styled-components';
import { themeColor } from '../theme/colors';
import { smRegular } from '../theme/typography';

export const ItemCounter = styled.div`
  display: flex;
  padding: 4px 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;

  color: ${themeColor('textTertiary')};
  ${smRegular}
  line-height: 138%;
`;
